/**
 * Returns whether the provided association number is valid
 *
 * @param number - string;
 */
export const isValidAssociationNumber = (number: string): boolean => {
	return /^V\d{7}$/.test(number);
};
